export const EMOTION_DESCRIPTION = `<p>
      Events AI Emotion uses natural language processing and machine learning
      algorithms to identify and categorize emotions expressed in textual data.
      Our model is trained to recognize six basic emotions derived from
      psychological research (anger, disgust, fear, joy, sadness and surprise),
      along with "neutral".
    </p>
    <p>
      The number on the y-axis of the EventsAI emotions chart represents the
      number of data points that have been categorized as that emotion. Neutral
      data points are not displayed on the graph.
    </p>
    <p>
      You can use EventsAI Emotion in combination with other features of Seerist
      to understand sentiment around events, individuals, or types of threats.
      EventsAI Emotion works best when looking at results in aggregate, rather
      than at individual or small numbers of data points. It is best used to
      visualize spikes in emotion and changes over time.
    </p>`;
